import React from "react";
import useSmartviewManager from "../hooks/use-smartview-manager";
import {useWillPipe} from "@morningtrain/react-helpers";

export default function GoToPreviousSmartviewOnPipe() {

    const manager = useSmartviewManager();

    useWillPipe((payload) => {
        return new Promise((resolve, reject) => {
            Promise.resolve(manager.back())
                .then(() => {
                    resolve(payload);
                })
                .catch(err => {
                    reject(err);
                });
        });
    });

    return null;
}
